import {
    Grid,
    InputAdornment,
    TableBody,
    TableCell,
    TableRow,
    Toolbar,
    Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { IoMdAdd } from "react-icons/io";
import Admin from "../../components/auth/Admin";
import { isAuth } from "../../actions/auth";
import Controls from "../../components/controls/Controls";
import Notify from "../../components/customHelpers/Notify";
import Popup from "../../components/customHelpers/Popup";
import JobForm from "../../components/forms/JobForm";
import Layout from "../../components/layout/Layout";
import Jobs from "../../actions/Jobs";
import useTable from "../../components/customHelpers/useTable";
import { MdOutlineDelete } from "react-icons/md";
import { FiEdit, FiEye } from "react-icons/fi";
import Loading from "../../components/customHelpers/Loading";
import Norecords from "../../components/customHelpers/Norecords";
import Notification from "../../components/customHelpers/Notification";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";

const headCells = [
    { id: "title", label: "Job Title" },
    { id: "status", label: "Status" },
    { id: "createdAt", label: "Posted At" },
    { id: "actions", label: "Actions", disableSorting: true },
];

const makeData = (result) => {
    return result.map((data) => {
        const statusRaw = data.status || (data.approved === true ? "approved" : "pending");
        const status = statusRaw === "pending" ? "Waiting for approval" : statusRaw;
        return {
            title: data.Title || data.title, // Handle capitalized key from backend
            Id: data.Id,
            body: data.Body || data.body,
            author: data.Author || data.author,
            createdAt: data.createdAt,
            status,
        };
    });
};

const CompanyJobs = () => {
    const { deleteJob, getUserJobs } = Jobs();
    const [openPopup, setOpenPopup] = useState(false);
    const { NotifyMessage, notify, setNotify } = Notify();
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
    });

    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });
    const [values, setValues] = useState({
        loading: false,
        jobs: [],
        reload: false,
    });
    const { loading, jobs, reload } = values;

    useEffect(() => {
        fetchCompanyJobs();
    }, [reload]);

    const fetchCompanyJobs = () => {
        setValues({ ...values, loading: true });
        const user = isAuth();
        getUserJobs(user?.email).then((data) => {
            if (data.err) {
                NotifyMessage({ message: data.err, type: "error" });
                setValues({ ...values, loading: false });
            } else {
                setValues({
                    ...values,
                    jobs: makeData(data.result || []),
                    loading: false,
                });
            }
        });
    };

    const handleSearch = (e) => {
        let target = e.target;
        setFilterFn({
            fn: (items) => {
                if (target.value === "") return items;
                return items.filter((x) =>
                    x.title.toLowerCase().includes(target.value.toLowerCase())
                );
            },
        });
    };

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
        useTable(
            jobs.sort((a, b) =>
                a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
            ),
            headCells,
            filterFn
        );

    const onDelete = (Id) => {
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        deleteJob(Id).then((data) => {
            if (data.err) {
                NotifyMessage({ message: data.err, type: "error" });
            } else {
                NotifyMessage({ message: data.message, type: "success" });
                setValues({ ...values, reload: !reload });
            }
        });
    };

    return (
        <Layout>
            <Admin>
                <div className="card">
                    <Typography variant="h6" className="page-header">
                        My Job Posts
                    </Typography>
                    <Toolbar>
                        <Controls.Input
                            label="Search My Jobs"
                            className="searchInput"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <AiOutlineSearch />
                                    </InputAdornment>
                                ),
                            }}
                            onChange={handleSearch}
                        />
                        <Controls.Button
                            text="Create Job Post"
                            variant="outlined"
                            startIcon={<IoMdAdd />}
                            className="newButton"
                            onClick={() => {
                                setOpenPopup(true);
                                setRecordForEdit(null);
                            }}
                        />
                    </Toolbar>
                    <Grid container>
                        <Grid item xs={12} className="card__body">
                            {loading ? (
                                <Loading />
                            ) : (
                                <>
                                    <TblContainer>
                                        <TblHead />
                                        <TableBody>
                                            {recordsAfterPagingAndSorting().length > 0 ? (
                                                recordsAfterPagingAndSorting().map((item) => (
                                                    <TableRow key={item.Id}>
                                                        <TableCell>{item.title}</TableCell>
                                                        <TableCell>{item.status}</TableCell>
                                                        <TableCell>
                                                            {new Date(item.createdAt).toLocaleString()}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Controls.ActionButton
                                                                color="primary"
                                                                onClick={() => {
                                                                    setRecordForEdit({ ...item, editing: true });
                                                                    setOpenPopup(true);
                                                                }}
                                                            >
                                                                <FiEdit fontSize="medium" />
                                                            </Controls.ActionButton>
                                                            <Controls.ActionButton
                                                                color="secondary"
                                                                onClick={() => {
                                                                    setConfirmDialog({
                                                                        isOpen: true,
                                                                        title: "Delete job post?",
                                                                        subTitle: "This action cannot be undone.",
                                                                        onConfirm: () => onDelete(item.Id),
                                                                    });
                                                                }}
                                                            >
                                                                <MdOutlineDelete fontSize="medium" />
                                                            </Controls.ActionButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <Norecords col={4} />
                                            )}
                                        </TableBody>
                                    </TblContainer>
                                    <TblPagination />
                                </>
                            )}
                        </Grid>
                    </Grid>
                    <Popup
                        title="Job Post Form"
                        openPopup={openPopup}
                        setOpenPopup={setOpenPopup}
                    >
                        <JobForm
                            recordForEdit={recordForEdit}
                            NotifyMessage={NotifyMessage}
                            getAllJobs={fetchCompanyJobs}
                            setOpenPopup={setOpenPopup}
                            isCompany={true}
                            companyId={isAuth() ? isAuth().Id : null}
                        />
                    </Popup>
                    <Notification notify={notify} setNotify={setNotify} />
                    <ConfirmDialog
                        confirmDialog={confirmDialog}
                        setConfirmDialog={setConfirmDialog}
                    />
                </div>
            </Admin>
        </Layout>
    );
};

export default CompanyJobs;
